<template>
  <main class="el-main">
    <slot></slot>
  </main>
</template>

<script>
  export default {
    name: 'ElMain',
    componentName: 'ElMain'
  };
</script>



// WEBPACK FOOTER //
// src/components/element/packages/main/src/main.vue